import RawCard from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import {styled} from 'common'

const Card = ({children, contentStyle, ...p}) => {
    return (
        <StyledCard {...p}>
            <CardContent style={contentStyle}>{children}</CardContent>
        </StyledCard>
    )
}

export default Card

const StyledCard = styled(RawCard)`
    width: 100%;
`
